import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Sidebar from './SidebarProjectManager';

class Layout extends Component {
  static displayName = Layout.name;

  render() {
    const { location } = this.props;
    const pathname = location && location.pathname;
    const isProjectManagerHome =
      pathname === '/ProjectManager/MainMenu';
    const hideSidebarOnTextDetails = pathname === '/ProjectManager/TextDetails';
    const shellClassName = isProjectManagerHome
      ? 'app-shell app-shell--writer-home'
      : 'app-shell';
    return (
      <div style={{ backgroundColor: isProjectManagerHome ? '#F6F6F6' : 'transparent', minHeight: '100vh', width: '100%', margin: 0, padding: 0 }}>
        <div className={shellClassName} style={{ backgroundColor: isProjectManagerHome ? '#F6F6F6' : 'transparent', width: '100%', minHeight: '100vh' }}>
          {!hideSidebarOnTextDetails && <Sidebar />}
          <div className="wrapper-content" style={{ backgroundColor: isProjectManagerHome ? '#F6F6F6' : 'transparent' }}>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Layout);


